export default __webpack_public_path__ + "static/media/2231.a78107d0.png";